module.exports = __webpack_public_path__ + "static/FlexPrint-image-1fa47aaf3cdc9729df5351da04285044.png";